import { useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { AuthLayout } from '../components/AuthLayout';
import { PASSWORD_MIN_LENGTH } from '../auth';
import * as authRepository from '../repositories/authRepository';

export default function ResetPasswordPage() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token') || '';
  const [message, setMessage] = useState(token ? '' : 'Missing reset token in URL');
  const [isError, setIsError] = useState(!token);

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setMessage('');
    const form = new FormData(e.currentTarget);
    const password = String(form.get('password') || '');
    const confirmPassword = String(form.get('confirmPassword') || '');
    if (password !== confirmPassword) {
      setMessage('Passwords do not match');
      setIsError(true);
      return;
    }
    try {
      await authRepository.resetPassword(token, password);
      navigate('/login', { replace: true });
    } catch (err) {
      setMessage((err as Error).message || 'Failed to reset password');
      setIsError(true);
    }
  };

  return (
    <AuthLayout
      title="Set New Password"
      subtitle="Use the token from the reset email."
      message={message}
      isError={isError}
      footer={<Link to="/login">Back to sign in</Link>}
    >
      <form onSubmit={handleSubmit} className="auth-form">
        <label>
          <span>New password</span>
          <input type="password" name="password" autoComplete="new-password" minLength={PASSWORD_MIN_LENGTH} required />
        </label>
        <label>
          <span>Confirm new password</span>
          <input type="password" name="confirmPassword" autoComplete="new-password" minLength={PASSWORD_MIN_LENGTH} required />
        </label>
        <button type="submit" className="primary-button" disabled={!token}>Reset password</button>
      </form>
    </AuthLayout>
  );
}
